import { render, staticRenderFns } from "./contentCourseLectureExamMatching.vue?vue&type=template&id=f63d9b6a&"
import script from "./contentCourseLectureExamMatching.vue?vue&type=script&lang=js&"
export * from "./contentCourseLectureExamMatching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports